export const DELETE_ADDRESS = 'PROFILE/DELETE_ADDRESS'
export const ADD_ORDERS_WITHOUT_REVIEWS = 'PROFILE/ADD_ORDERS_WITHOUT_REVIEWS';
export const DECREASE_ORDERS_WITHOUT_REVIEW = 'PROFILE/DECREASE_ORDERS_WITHOUT_REVIEW';
export const SET_CURRENT_USER = 'PROFILE/SET_SET_CURRENT_USER';
export const SHOW_LOADER = 'PROFILE/SHOW_LOADER';
export const HIDE_LOADER = 'PROFILE/HIDE_LOADER';
export const UPDATE_USER_POINTS = 'PROFILE/UPDATE_USER_POINTS';